import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, notification, Tooltip } from 'antd'
import { TableComp } from 'sz-react-utils'
import Request, { API_URL, MEDIA_URL } from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'

let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';

class AllWithdrawStudents extends Component {

  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    defaultPageSize: 10,
    showWithdrawForm: false,
    recordId: '',
    formAction: '',
    enableBTN: false
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      let data = await Request.getInvoiceWithdrawalList({
        ...params,
        regExFilters: [
          'studentName'
        ]
      });
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  async componentDidMount() {

  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  closeWithdrawFrom = () => {
    this.setState({ showWithdrawForm: false });
  }


  printInvoiceDate = (nextInvoiceGenerationDates) => {
    if (nextInvoiceGenerationDates.length) {
      let generatedInvoices = nextInvoiceGenerationDates.filter(item => (item.withdrawRequest === true && (item.withdrawRequstStatus === 'Approve' || item.withdrawRequstStatus === 'Approved By TPSC')));
      return generatedInvoices.length > 0 ? generatedInvoices[0] : null;
    }
  }

  rollbackStudentToFinanceClaimDesk = async (record) => {
    let invoiceGenerationRecord = this.printInvoiceDate(record.nextInvoiceGenerationDates);
    let data = {};
    data.invoiceGeneratedRecordId = invoiceGenerationRecord._id
    data.recordId = record._id;

    let response = await Request.rollbackStudentToFinanceClaimDesk(data);
    if (!response.error) {
      if (this.table && this.table.current) {
        this.table.current.reload();
      }
      notification.success({ message: response.msg });
    } else {
      notification.error({
        message: 'Error Rollback student.'
      })
    }

  }

  render() {

    const { total, defaultPageSize, } = this.state;

    const columns = [
      {
        title: 'Action',
        key: 'checkboxMultiple',
        dataindex: 'checkboxMultiple',
        width: 140,
        render: (text, record) => (
          <React.Fragment>
            <div>
              <div className={styles.btnWrapper}>
                <Tooltip title="Rollback to Claim Desk">
                  &nbsp;<Button
                    loading={false}
                    className={styles.btn}
                    onClick={() => { this.rollbackStudentToFinanceClaimDesk(record) }}
                    shape="circle"
                    icon="rollback"
                  />
                </Tooltip>
              </div>
            </div>
          </React.Fragment>
        )
      },
      {
        title: 'VID',
        key: 'id',
        dataIndex: 'id',
        sorter: true,
        width: 80,
        searchTextName: 'id',
        filterRegex: true,
        render: (text, record) => (
          <a target={'_blank'} href={`/desk/getClaim?id=${record._id}`}>{text}</a>
        )
      },
      {
        title: 'Student Details',
        key: 'studentDetails',
        dataIndex: 'studentName',
        sorter: true,
        width: 200,
        searchTextName: 'studentName',
        filterRegex: true,
        render: (text, record) => (
          <div >
            <React.Fragment>
              <div>
                <Tooltip title="Click To Edit Details">
                  <a target={'_blank'}
                    href={`/inquiry/studentProfileDetails?id=${record._id}`}
                  >{text}</a>
                </Tooltip>
                <div><b>Mobile:-</b> {record.mobile}</div>
                <div><b>Email:-</b> {record.emailId}</div>
                <div><b>Student ID:-</b> {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.instituteStudentId : 'NA'}</div>
              </div>
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'University Details',
        key: 'universityDetails',
        width: 200, // Increased width for better readability
        searchTextName: 'universityDetails',
        render: (text, record) => {
          let visaDesk = record && record.visaDesk ? record.visaDesk : null;
          let selectedCourse = visaDesk && visaDesk.selectedCourse ? visaDesk.selectedCourse : null;

          // Determine Partner Display
          let isPartner = selectedCourse && selectedCourse.channelPartnerName && selectedCourse.channelPartnerId;
          let partnerName = isPartner ? selectedCourse.channelPartnerName : 'Direct';

          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              {/* University Name - Primary Detail */}
              <div style={{ fontWeight: 600, color: '#262626', lineHeight: '1.2' }}>
                {selectedCourse && selectedCourse.universityInstitutionName ? selectedCourse.universityInstitutionName : 'N/A'}
              </div>

              {/* Partnership Status - Secondary Detail */}
              <div>
                {isPartner ? (
                  <span style={{
                    fontSize: '11px',
                    color: '#1890ff',
                    background: '#e6f7ff',
                    padding: '1px 6px',
                    borderRadius: '4px',
                    border: '1px solid #91d5ff',
                    display: 'inline-block'
                  }}>
                    {partnerName}
                  </span>
                ) : (
                  <span style={{ fontSize: '11px', color: '#8c8c8c' }}>
                    {partnerName}
                  </span>
                )}
              </div>
            </div>
          );
        }
      },
      {
        title: 'Term / Invoice Generation Date',
        key: 'invoiceGenerationDates',
        dataIndex: 'nextInvoiceGenerationDates',
        searchTextName: `Search Term`,
        width: 100,
        render: (text, record) => {

          const invoice = this.printInvoiceDate(record.nextInvoiceGenerationDates);

          return (
            <div>
              {invoice ? (
                <div>
                  <b>{"T" + (invoice.invoiceNo || "")}</b>{"/"}
                  {moment(invoice.generationDate).format(dateFormat)}
                </div>
              ) : null}
            </div>
          );
        }
      },
      {
        title: 'Withdrawal Reason',
        key: 'withdrawReason',
        dataIndex: 'withdrawReason',
        searchTextName: 'Withdrawal Reason',
        width: 100,
        render: (text, record) => (
          <div >
            <React.Fragment>
              <div>
                {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawReason : null}
              </div>
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Withdrawal Request Submission Date',
        key: 'withdrawDate',
        dataIndex: 'withdrawDate',
        searchTextName: `Withdraw Request Date ${dateFormat}`,
        width: 100,
        render: (text, record) => (
          <div >
            <React.Fragment>
              <div>
                {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? moment(this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawReasonDate).local().format(dateFormat) : null}
              </div>
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Withdrawal Proof',
        key: 'mailFromUniversity',
        dataIndex: 'mailFromUniversity',
        width: 100,
        render: (text, record) => (
          <div >
            <React.Fragment>
              <div>
                {
                  this.printInvoiceDate(record.nextInvoiceGenerationDates) &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity.length &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity[0].url ?
                    <div><b>Mail From Univerisity:</b> <a href={MEDIA_URL + this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity[0].url} target="_blank" rel='noopener noreferrer'>View</a></div>
                    : null
                }
                {
                  this.printInvoiceDate(record.nextInvoiceGenerationDates) &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent.length &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent[0].url ?
                    <div><br /><b>Mail From Student:</b> <a href={MEDIA_URL + this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent[0].url} target="_blank" rel='noopener noreferrer'>View</a></div>
                    : null
                }
                {
                  this.printInvoiceDate(record.nextInvoiceGenerationDates) &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument.length &&
                    this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument[0].url ?
                    <div><br /><b>Other Document:</b> <a href={MEDIA_URL + this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument[0].url} target="_blank" rel='noopener noreferrer'>View</a></div>
                    : null
                }
              </div>
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Stage',
        key: 'withdrawFinalStageNote',
        dataIndex: 'withdrawFinalStageNote',
        width: 100,
        render: (text, record) => {
          const invoiceData = this.printInvoiceDate(record.nextInvoiceGenerationDates);

          const approvedUser =
            invoiceData &&
            invoiceData.withdrawApprovedBy &&
            invoiceData.withdrawApprovedBy;

          return (
            <div>
              <div>
                <b>Note:</b>{' '}
                {invoiceData ? invoiceData.withdrawFinalStageNote : '-'}
                <br />

                <b>Status:</b>{' '}
                {invoiceData ? invoiceData.withdrawRequstStatus : '-'}
                <br />

                <b>Approved By:</b>{' '}
                {approvedUser ? approvedUser.name : '-'}
                {approvedUser && approvedUser.time
                  ? moment(approvedUser.time).format('DD-MM-YYYY hh:mm A')
                  : '-'}
              </div>
            </div>
          );
        }
      }
    ];

    // const columns = [
    //   {
    //     title: 'Action',
    //     key: 'checkboxMultiple',
    //     dataindex: 'checkboxMultiple',
    //     width: 140,
    //     render: (text, record) => (
    //       <React.Fragment>
    //         <div>
    //           <div className={styles.btnWrapper}>
    //             <Tooltip title="Rollback to Claim Desk">
    //               &nbsp;<Button
    //                 loading={false}
    //                 className={styles.btn}
    //                 onClick={() => { this.rollbackStudentToFinanceClaimDesk(record) }}
    //                 shape="circle"
    //                 icon="rollback"
    //               />
    //             </Tooltip>
    //           </div>
    //         </div>
    //       </React.Fragment>
    //     )
    //   },
    //   {
    //     title: 'VID',
    //     key: 'id',
    //     dataIndex: 'id',
    //     sorter: true,
    //     width: 80,
    //     searchTextName: 'id',
    //     filterRegex: true
    //   },
    //   {
    //     title: 'Student Name',
    //     key: 'studentName',
    //     dataIndex: 'studentName',
    //     sorter: true,
    //     width: 200,
    //     searchTextName: 'studentName',
    //     filterRegex: true,
    //     render: (text, record) => (
    //       <div className={styles.wrap}>
    //         <React.Fragment>
    //           <div>
    //             <Tooltip title="Click To Edit Details">
    //               <a className={styles.btn} target={'_blank'}
    //                 href={`/inquiry/studentProfileDetails?id=${record._id}`}
    //               >{text}</a>
    //             </Tooltip>
    //             <div><b>Mobile:-</b> {record.mobile}</div>
    //             <div><b>Email:-</b> {record.emailId}</div>
    //             <div><b>Student ID:-</b> {record.visaDesk.selectedCourse ? record.visaDesk.selectedCourse.instituteStudentId : 'NA'}</div>
    //           </div>
    //         </React.Fragment>
    //       </div>
    //     )
    //   },
    //   {
    //     title: 'Next Invoice Generation Date',
    //     key: 'nextInvoiceGenerationDates',
    //     dataIndex: 'nextInvoiceGenerationDates',
    //     width: 100,
    //     render: (text, record) => (
    //       <div className={styles.wrap}>
    //         <React.Fragment>
    //           <div>
    //             {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? moment(this.printInvoiceDate(record.nextInvoiceGenerationDates).generationDate).format(dateFormat) : null}
    //           </div>
    //         </React.Fragment>
    //       </div>
    //     )
    //   },
    //   {
    //     title: 'Withdrawal Reason',
    //     key: 'withdrawReason',
    //     dataIndex: 'withdrawReason',
    //     width: 100,
    //     render: (text, record) => (
    //       <div className={styles.wrap}>
    //         <React.Fragment>
    //           <div>
    //             {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawReason : null}
    //           </div>
    //         </React.Fragment>
    //       </div>
    //     )
    //   },
    //   {
    //     title: 'Withdrawal Date',
    //     key: 'withdrawDate',
    //     dataIndex: 'withdrawDate',
    //     width: 100,
    //     render: (text, record) => (
    //       <div className={styles.wrap}>
    //         <React.Fragment>
    //           <div>
    //             {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? moment(this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawDate).format(dateFormat) : null}
    //           </div>
    //         </React.Fragment>
    //       </div>
    //     )
    //   },
    //   {
    //     title: 'Withdraw Finance Note',
    //     key: 'withdrawFinanceNote',
    //     dataIndex: 'withdrawFinanceNote',
    //     width: 100,
    //     render: (text, record) => (
    //       <div className={styles.wrap}>
    //         <React.Fragment>
    //           <div>
    //             <b>Note:</b> {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawFinanceNote : null}
    //             <br />
    //             <b>Status:</b> {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawFinanceRequest : null}
    //           </div>
    //         </React.Fragment>
    //       </div>
    //     )
    //   },
    //   {
    //     title: 'Documents',
    //     key: 'mailFromUniversity',
    //     dataIndex: 'mailFromUniversity',
    //     width: 100,
    //     render: (text, record) => (
    //       <div className={styles.wrap}>
    //         <React.Fragment>
    //           <div>
    //             {
    //               this.printInvoiceDate(record.nextInvoiceGenerationDates) &&
    //                 this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity &&
    //                 this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity.length &&
    //                 this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity[0].url ?
    //                 <div><b>Mail From Univerisity:</b> <a href={MEDIA_URL + this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromUniversity[0].url} target="_blank" rel="noopener noreferrer">View</a></div>
    //                 : null
    //             }
    //             {
    //               this.printInvoiceDate(record.nextInvoiceGenerationDates) &&
    //                 this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent &&
    //                 this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent.length &&
    //                 this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent[0].url ?
    //                 <div><br /><b>Mail From Univerisity:</b> <a href={MEDIA_URL + this.printInvoiceDate(record.nextInvoiceGenerationDates).mailFromStudent[0].url} target="_blank" rel="noopener noreferrer">View</a></div>
    //                 : null
    //             }
    //             {
    //               this.printInvoiceDate(record.nextInvoiceGenerationDates) &&
    //                 this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument &&
    //                 this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument.length &&
    //                 this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument[0].url ?
    //                 <div><br /><b>Mail From Univerisity:</b> <a href={MEDIA_URL + this.printInvoiceDate(record.nextInvoiceGenerationDates).otherDocument[0].url} target="_blank" rel="noopener noreferrer">View</a></div>
    //                 : null
    //             }
    //           </div>
    //         </React.Fragment>
    //       </div>
    //     )
    //   },
    //   {
    //     title: 'Withdraw Final Stage',
    //     key: 'withdrawFinalStageNote',
    //     dataIndex: 'withdrawFinalStageNote',
    //     width: 100,
    //     render: (text, record) => (
    //       <div className={styles.wrap}>
    //         <React.Fragment>
    //           <div>
    //             <b>Note:</b> {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawFinalStageNote : null}
    //             <br />
    //             <b>Status:</b> {this.printInvoiceDate(record.nextInvoiceGenerationDates) ? this.printInvoiceDate(record.nextInvoiceGenerationDates).withdrawRequstStatus : null}
    //           </div>
    //         </React.Fragment>
    //       </div>
    //     )
    //   }
    // ]

    return (
      <PageHeaderWrapper title={` Withdrawn Students ${total} `}>
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 900 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: defaultPageSize,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllWithdrawStudents
